export function getApiErrorMessage(error, fallback = "Something went wrong. Please try again.") {
  const serverMessage = error?.response?.data?.message;
  if (serverMessage) return serverMessage;

  if (!error?.response) {
    return "Can't reach the server. Check that the backend is running and reachable from this device.";
  }

  return fallback;
}
